import { motion } from "framer-motion";
import { Lotus } from "./Lotus";
import { BRAND, whatsappLink } from "../../data";

const ABOUT_IMG =
  "https://customer-assets.emergentagent.com/job_zen-massage-retreat/artifacts/yzsetum8_Messenger_creation_95AE4D2A-A569-4CC3-A81E-5A7EFB84CE0F.webp";

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-28 px-6 bg-[#151c0f] overflow-hidden"
    >
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        >
          <div className="flex items-center gap-3">
            <Lotus className="w-7 h-5 text-[#b89d62]" />
            <span className="eyebrow">Our Story</span>
          </div>
          <h2 className="font-serif-display font-light text-4xl sm:text-5xl text-[#faf9f6] mt-5 tracking-tight leading-tight">
            A sanctuary of Thai healing in Barcelona
          </h2>
          <div className="mt-8 space-y-5 text-[#c9d3ca] font-light leading-relaxed">
            <p>
              <span className="font-serif-display text-5xl text-[#b89d62] float-left mr-3 leading-[0.8]">
                R
              </span>
              oyale was born from a love of traditional Thai therapy and the belief
              that true wellbeing begins with intentional, unhurried care. Every
              session is a quiet escape — a moment to breathe, restore and reconnect
              with yourself.
            </p>
            <p>
              Led by Regina, our therapist blends ancient techniques with warm oils,
              herbal compresses and candle rituals, tailored to soothe your body,
              nourish your skin and calm your soul.
            </p>
          </div>

          <div className="mt-10 flex flex-wrap gap-8">
            {[
              { k: "Signature", v: "Rituals" },
              { k: "100%", v: "Natural Oils" },
              { k: "From €68", v: "per hour" },
            ].map((s) => (
              <div key={s.v}>
                <p className="font-serif-display text-3xl text-[#b89d62]">{s.k}</p>
                <p className="eyebrow mt-1 !text-[#c9d3ca]">{s.v}</p>
              </div>
            ))}
          </div>

          <a
            data-testid="about-whatsapp-cta"
            href={whatsappLink()}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-10 inline-flex items-center gap-2 border border-[#b89d62] text-[#b89d62] hover:bg-[#b89d62] hover:text-[#151c0f] transition-all duration-400 px-8 py-4 btn-label"
          >
            Say hello on WhatsApp
          </a>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
          className="relative"
        >
          <div className="absolute -inset-3 border border-[#b89d62]/30 translate-x-4 translate-y-4" />
          <img
            src={ABOUT_IMG}
            alt="Royale spa ambience"
            className="relative w-full h-[520px] object-cover"
          />
        </motion.div>
      </div>
    </section>
  );
};
